import { ApiClient, ApiCurrency } from "@incendium/api";
import { Box, Button, Divider, Stack, TextField } from "@mui/material";
import { updateProject } from "Actions";
import TimezoneSelect from "Components/TimezoneSelect/TimezoneSelect";
import { useCallback, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch } from "react-redux";
import { saveProject } from "features/project";
import { IOnboardStepProps } from "features/onboarding/types";
import { CurrencyPicker } from "features/currency";
import { CallbackOrVal } from "Interfaces";
import { useNotification } from "Hooks";

interface IIOnboardStepPropsProps extends IOnboardStepProps {
  client: ApiClient;
}

function OnboardingStepBasicInfo({

  project,
  client,
}: IIOnboardStepPropsProps) {
  const dispatch = useDispatch();
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const [timezone, setTimezone] = useState(
    project?.timezone
      ? project?.timezone
      : project?.timezone
        ? project?.timezone
        : ""
  );
  const [currency, setCurrency] = useState(project.currency);

  // Track if form has changed from original values
  const dirty = timezone !== project?.timezone || currency !== project?.currency;

  const onSubmit = useCallback(async () => {
    // handle project
    try {
      if (timezone !== project?.timezone || currency !== project?.currency) {
        const res = await saveProject(project?.clientId as number, {
          ...project,
          timezone,
          currency,
        });

        dispatch(updateProject(res));
        showSuccessNotification(`Project Saved`);
      }
    } catch (e) {
      showErrorNotification("There was an error saving the project, please try again");
    }

  }, [project, timezone, currency, dispatch, showSuccessNotification, showErrorNotification]);
  return (
    <ValidatorForm onSubmit={onSubmit} style={{ height: "100%" }}>
        <Stack justifyContent="space-between" height="100%">
          <Stack mb={3} spacing={3}>
            <TextField
              label="Company / Client Name"
              fullWidth
              size="medium"
              variant="outlined"
              value={client?.businessName || ""}
              disabled
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label="Project Name"
              fullWidth
              size="medium"
              variant="outlined"
              value={project?.name || ""}
              disabled
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label="Website URL"
              fullWidth
              size="medium"
              variant="outlined"
              value={project?.domains?.[0].domain || ""}
              disabled
              InputProps={{
                readOnly: true,
              }}
              helperText="You will be able to add any subdomains later"
            />

            <TimezoneSelect
              value={timezone}
              fullWidth
              size="medium"
              variant="outlined"
              label="Timezone"
              onChange={(e) => setTimezone(e.target.value)}
            />

            <CurrencyPicker
              size="medium"
              currency={currency}
              setCurrency={setCurrency as (v: CallbackOrVal<ApiCurrency>) => void}
              label="Currency Symbol"
              helperText="Select Project currency symbol to display in reporting."
            />
          </Stack>
          <Box>
            <Divider />
            <Stack direction={"row"} spacing={2} mt={2} justifyContent="flex-end">
              <Button fullWidth color="primary" size="large" type="submit" disabled={!dirty}>
                Save Changes
              </Button>
            </Stack>
          </Box>
        </Stack>
      </ValidatorForm>
  );
}

export default OnboardingStepBasicInfo;
